import Checkbox from '@/components/Checkbox';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import * as store from '@/store';
import styles from './index.module.scss';

export const MAX_COUNT = 100;

function CustomCheckbox({onClick, checked, halfChecked, disableCheckbox}: any) {
    const isFull = store.getTreeSelectedFull();
    const disabled = !checked && !halfChecked && isFull;
    return disabled ? (
        <Tooltip
            placement="right"
            trigger={TooltipTrigger.Hover}
            content={`最大选择${MAX_COUNT}篇文档`}
        >
            <Checkbox
                className={styles.checkbox}
                checked={checked}
                indeterminate={halfChecked}
                disabled
            />
        </Tooltip>
    ) : (
        <Checkbox
            className={styles.checkbox}
            checked={checked}
            indeterminate={halfChecked}
            disabled={disableCheckbox}
            onClick={(event: any, ...props) => {
            // 阻止冒泡，防止触发select事件
                event.stopPropagation();
                onClick(event, ...props);
            }}
        />
    );
}

export default CustomCheckbox;
